import { useState } from 'react';
import UserInfoPanel from 'components/UserInfo/UserInfoPanel';
import NavigationBar from 'components/NavigationBar';
import AppSwitcherModal from 'components/NavigationBar/AppSwitcherModal';
import { useLocation } from 'react-router-dom';
import classes from './AppBar.module.scss';

const AppBar = () => {
    const [userModalOpen, setUserModalOpen] = useState(false);
    const [isAppSwitcherOpen, setIsAppSwitcherOpen] = useState(false);
    const location = useLocation();

    return (
        <div data-testid="appbar" className={classes.appbar} data-page={location.pathname.substring(1)}>
            <NavigationBar setUserModalOpen={setUserModalOpen} setIsAppSwitcherOpen={setIsAppSwitcherOpen} />
            <AppSwitcherModal isAppSwitcherOpen={isAppSwitcherOpen} setIsAppSwitcherOpen={setIsAppSwitcherOpen} />
            <UserInfoPanel userModalOpen={userModalOpen} setUserModalOpen={setUserModalOpen} />
        </div>
    );
};

export default AppBar;
